module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Arrow-to-left-8f17bb1ac47ae1f4b9742eb918925403.svg";